'use client'

import { useEffect, useRef, useState, type ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

interface VoiceWorkspaceLayoutProps {
  left: ReactNode
  right: ReactNode
  className?: string
}

/**
 * 双栏布局：左侧自然高度，桌面端右侧高度与左侧对齐，列表在 OutputPanel 内滚动。
 */
export const VoiceWorkspaceLayout = ({ left, right, className }: VoiceWorkspaceLayoutProps) => {
  const leftRef = useRef<HTMLDivElement>(null)
  const [matchedHeight, setMatchedHeight] = useState<number>()

  useEffect(() => {
    const el = leftRef.current
    if (!el) return

    const syncHeight = () => {
      setMatchedHeight(el.getBoundingClientRect().height)
    }

    syncHeight()

    const ro = new ResizeObserver(syncHeight)
    ro.observe(el)

    window.addEventListener('resize', syncHeight)
    return () => {
      ro.disconnect()
      window.removeEventListener('resize', syncHeight)
    }
  }, [])

  return (
    <div className={cn('grid grid-cols-1 items-start gap-4 lg:grid-cols-2 lg:gap-5', className)}>
      <div ref={leftRef}>{left}</div>
      <div
        className="hidden min-h-0 lg:block"
        style={matchedHeight ? { height: matchedHeight } : undefined}
      >
        <div className="h-full">{right}</div>
      </div>
    </div>
  )
}
